/* eslint-disable no-param-reassign */

/* ============
 * Admin Users Mutations
 * ============
 *
 * The mutations available for the admin-users module.
 */

import * as types from './types';

export default {
  /**
   * Mutation to update the store with the fetched users.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  users      The fetched users.
   * @param {Object} pagination The fetched pagination.
   */
  [types.ALL](state, { users, pagination }) {
    state.all = users;
    state.pagination = pagination;
  },

  /**
   * Mutation to update the store when the request to fetch users fails
   *
   * @param {any} state The current state of the store
   */
  [types.NONE](state) {
    state.all = [];
    state.pagination.totalCount = 0;
    state.pagination.totalPages = 1;
    state.pagination.limit = 20;
  },

  /**
   * Mutation to respond to the action when a user has been created.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} user  The user that has been created.
   */
  [types.CREATED](state, user) {
    const {
      totalCount,
      limit,
    } = state.pagination;

    state.pagination.totalCount += 1;

    if (totalCount % limit === 0) {
      state.pagination.totalPages += 1;
    }

    if (limit > state.all.length) {
      state.all.push(user);
    }
  },

  /**
   * Mutation to respond to the action when a user has been updated.
   *
   * @param {Object} state The current state of the store.
   * @param {Object} user  The user that has been updated.
   */
  [types.UPDATED](state, user) {
    state.all = state.all.map((item) => {
      if (item.id === user.id) {
        return user;
      }

      return item;
    });
  },

  /**
   * Mutation to give a value to the path list
   *
   * @params {Object} state The current state of the store.
   * @params {Object} list The new value of the path list
   */
  [types.SET_PATH](state, list) {
    state.menu.pathList = list;
  },


  /**
   * Mutation to add an item to the pathlist
   *
   * @params {Object} state The current state of the store.
   * @params {Object} item The item to be added to the list
   */
  [types.ADD_TO_PATH](state, item) {
    state.menu.pathList.push(item);
  },

  /**
   * Mutation to remove an item from the pathlist
   *
   * @params {Object} state The current state of the store.
   * @params {Number} index The new last index of the list
   */
  [types.SLICE_PATH](state, index) {
    state.menu.pathList = state.menu.pathList.slice(0, (index + 1));
  },

  [types.REMOVE_LAST_PATH_ITEM](state) {
    state.menu.pathList.splice(-1, 1);
  },

  /**
   * Mutation to add a new value to the current item
   *
   * @params {Object} state The current state of the store.
   * @params {Object} item The new current item value
   */
  [types.SET_CURRENT_ITEM](state, item) {
    state.menu.currentItem = item;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/admin-users/mutations.js